export function setElementVisibility(selector: string, show: boolean) {
  const element = document.querySelector(selector);
  if (element) {
    const style = (element as HTMLElement).style;
    if (show) {
      style.removeProperty('display');
    } else {
      style.display = 'none';
    }
  } else {
    console.error(`Unable to find page element with selector "${selector}" to set visibility of.`);
  }
}
